import { CustomCellEditorProps } from "ag-grid-react";
import { Select } from "antd";
import { useMemo } from "react";

const { Option } = Select;

type Role = {
  id: number;
  name: string;
  type_id: number;
};

type Props = CustomCellEditorProps;

function ProjectCompanyRoleSelectCellEditor(props: Props) {
  const { stopEditing, context, onValueChange } = props;
  const { companyTypes = [] } = context;

  const companyRoles = useMemo(() => {
    return companyTypes?.user_types;
  }, [companyTypes]);

  return (
    <Select
      open
      allowClear
      optionFilterProp="label"
      virtual={false}
      style={{ width: "100%" }}
      showSearch
      data-testid="projectcompanyrolecelleditor-select-companyrole"
      // notFoundContent={loading ? "" : notFoundContent}
      onChange={(id) => {
        onValueChange(id);
        setTimeout(() => {
          stopEditing();
        }, 200);
      }}
      loading={!companyRoles}
    >
      {companyRoles &&
        companyRoles?.map((role: Role) => (
          <Option key={role.id} value={role.id}>
            {role.name}
          </Option>
        ))}
    </Select>
  );
}

export default ProjectCompanyRoleSelectCellEditor;
